import { MSL_API_URL } from 'environment';

export async function uploadFileAPI(token, file, directory) {
  var myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${token}`);

  var formdata = new FormData();
  formdata.append('file', file);
  formdata.append('directory', directory);

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: formdata,
    redirect: 'follow',
  };

  return fetch(`${MSL_API_URL}/utility/file-upload`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}
